<template>
  <div class="container-fluid w-50">
    <div class="row">
      <div
        v-for="resource in getAllProjects.filter((x) => x.HasAccess)"
        class="col-md-6 mt-4"
        v-bind:key="resource"
      >
        <default-info-card
          :classIcon="resource.IconClass"
          :title="resource.Title"
          :to="resource.Link"
          :showButton="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {DefaultInfoCard }from "@/components/exporter.js";
import { mapGetters } from "vuex";

export default {
  name: "dashboard-default",
  components: {
    DefaultInfoCard,
  },
  computed: mapGetters(["getAllProjects", "getIsLogined"]),
};
</script>
